export default __webpack_public_path__ + "static/04-049bf195d73b53b168419b0f8548c554.jpg";